import { ApplicationLayoutState, ApplicationLayoutActionTypes, ThemeColors, ApplicationLayoutActions } from "./types";

// Initial state
const initialState: ApplicationLayoutState = {
  type: "dark",
  primaryColor: ThemeColors.lightGreen,
  secondaryColor: ThemeColors.blue,
  isSidebarOpen: true,
};

// The reducer function
export function applicationLayoutReducer(state = initialState, action: ApplicationLayoutActions) {
  switch (action.type) {
    case ApplicationLayoutActionTypes.SET_THEME: {
      return { ...state, type: action.payload };
    }
    case ApplicationLayoutActionTypes.SET_PRIMARY: {
      return { ...state, primaryColor: action.payload };
    }
    case ApplicationLayoutActionTypes.SET_SECONDARY: {
      return { ...state, secondaryColor: action.payload };
    }
    case ApplicationLayoutActionTypes.SET_SIDEBAR: {
      return { ...state, isSidebarOpen: action.payload };
    }

    default: {
      return state;
    }
  }
}
